import pixAxiosSyncRequests from '@/axios/pixAxiosSyncRequests.js';
import pixAxios from '@/axios/pixAxios.js';

export default {
  getParamListEnumByParamId: (paramId, langCode, instance) => {
    return pixAxios.get(`api/Common/GetParamListEnumByParamId?paramId=${paramId}&langCode=${langCode}&instance=${instance}`).then(({ data }) => data);
  },

  getParamListEnumByParamCode: (paramCode, langCode, instance) => {
    return pixAxios.get(`api/Common/GetParamListEnumByParamCode?paramCode=${paramCode}&langCode=${langCode}&instance=${instance}`).then(({ data }) => data);
  },

  VAS_GetParamListRel: (id, instance) => {
    return pixAxios.get(`/api/Common/VAS_GetParamListRel?typeInfo=${id}&instance=${instance}`).then(({ data }) => data);
  },

  searchParamListEnum: (paramlist) => {
    return pixAxios.post('/api/Common/SearchParamListEnum', paramlist).then(({ data }) => data);
  },

  addParamList: (newParamList) => {
    return pixAxios.post('api/Common/AddParamList', newParamList).then(({ data }) => data);
  },

  editParamList: (newParamList) => {
    return pixAxios.post('api/Common/EditParamList', newParamList).then(({ data }) => data);
  },

  deleteParamList: (paramId) => {
    return pixAxios.post(`/api/Common/DeleteParamList?paramId=${paramId}`).then(({ data }) => data);
  },

  addParamListEnum: (paramListEnumFormated) => {
    return pixAxios.post('api/Common/AddParamListEnum', paramListEnumFormated).then(({ data }) => data);
  },

  updateParamListEnum: (newParamListEnum) => {
    return pixAxios.post('api/Common/UpdateParamListEnum', newParamListEnum).then(({ data }) => data);
  },

  deleteParamListEnum: (paramId) => {
    return pixAxios.post(`/api/Common/DeleteParamListEnum?id=${paramId}`).then(({ data }) => data);
  },

  getUsersByInstance: (instance) => {
    return pixAxiosSyncRequests.get(`api/Users/GetUsersByInstance?instance=${instance}`).then(({ data }) => data);
  },
};
